import { render, staticRenderFns } from "./purreturndetailview.vue?vue&type=template&id=6fa0ee66&scoped=true&"
import script from "./purreturndetailview.vue?vue&type=script&lang=js&"
export * from "./purreturndetailview.vue?vue&type=script&lang=js&"
import style0 from "./purreturndetailview.vue?vue&type=style&index=0&id=6fa0ee66&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa0ee66",
  null
  
)

export default component.exports